// extracted by mini-css-extract-plugin
module.exports = {"mobileImage":"GamingPromotionBanner_mobileImage__hfjMV","desktopImage":"GamingPromotionBanner_desktopImage__2747t","close":"GamingPromotionBanner_close__ISau8"};